import { Item } from '../../types/benefit';
import { CheckboxSubItem } from './CheckboxSubItem';
import { NormalSubItem } from './NormalSubItem';
import { NotifySubItem } from './NotifySubItem';

interface Props {
  subItem: Item;
}

export const SubItem = ({ subItem }: Props) => {
  switch (subItem.type) {
    case 'normal':
      return <NormalSubItem {...subItem} />;
    case 'notify':
      return <NotifySubItem {...subItem} />;
    case 'checkbox':
      return <CheckboxSubItem {...subItem} />;
    default:
      return null;
  }
};
